import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const AppIntegritetspolicy = lazy(() => import("@/pages/info/AppIntegritetspolicy"));

export const Route = createFileRoute("/app-integritetspolicy")({
  head: () => seoHead("/app-integritetspolicy", { description: "Den här policyn beskriver hur Elmarknad Sverige AB behandlar personuppgifter när du använder vår mobilapp för iOS och Android. Den kompletterar vår allmänna dataskyddspolicy." }),
  component: () => <AppIntegritetspolicy />,
});
